var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "poll-title poll-title--centered" }, [
      _vm._v(_vm._s(_vm._("Дякуємо за ваші відповіді"))),
      _c("span", { staticClass: "poll-title__icon svgicon-smile" })
    ]),
    _c("p", { staticClass: "poll-text" }, [
      _vm._v(
        _vm._s(
          _vm._(
            "Даруємо вам промокод на 15% знижки для купівлі продукції бренду Milupa в офіційному інтернет магазині shop.nutricia.ua"
          )
        )
      )
    ]),
    _c("div", { staticClass: "poll-promo" }, [
      _c("p", { staticClass: "poll-promo__title" }, [
        _vm._v(_vm._s(_vm._("Ваш промокод:")))
      ]),
      _c(
        "div",
        { staticClass: "poll-promo__wrap" },
        [
          _c("p", { staticClass: "poll-promo__code" }, [
            _vm._v(_vm._s(_vm.promo) + " ")
          ]),
          _c("transition", { attrs: { name: "slidedown" } }, [
            _vm.show
              ? _c("div", { staticClass: "poll-promo__success" }, [
                  _vm._v(_vm._s(_vm._("Промокод успішно скопійован")))
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "clipboard",
                  rawName: "v-clipboard:copy",
                  value: _vm.promo,
                  expression: "promo",
                  arg: "copy"
                },
                {
                  name: "clipboard",
                  rawName: "v-clipboard:success",
                  value: _vm.successPromo,
                  expression: "successPromo",
                  arg: "success"
                }
              ],
              staticClass: "promo-tip"
            },
            [
              _c("div", { staticClass: "promo-tip__icon svgicon-copy" }),
              _c("p", { staticClass: "promo-tip__text" }, [
                _vm._v(_vm._s(_vm._("Копіювати код")))
              ])
            ]
          )
        ],
        1
      ),
      _c("p", { staticClass: "poll-promo__info" }, [
        _vm._v(
          _vm._s(
            _vm._(
              "Промокод можна використати 1 раз. Знижка діє на продукцію для дітей віком старше 6-ти місяців. Промокод дійсний до 31.08.2021 включно."
            )
          ) + "  "
        )
      ]),
      _c(
        "button",
        {
          staticClass: "poll-btn",
          attrs: { href: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.next(false)
            }
          }
        },
        [_vm._v(_vm._s(_vm._("Завершити")))]
      ),
      _c(
        "button",
        {
          staticClass: "poll-promo__btn poll-btn poll-btn--grey",
          attrs: { href: "", target: "_blank" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.next(true)
            }
          }
        },
        [_vm._v(_vm._s(_vm._("У магазин")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4509b4fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4509b4fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/promo.vue
// module id = 217
// module chunks = 4